module.exports = __webpack_public_path__ + "img/member-trend.cc726a31.svg";